import React, {useEffect} from "react";
import { motion } from "framer-motion";
import { useCartContext } from "../../../context/cartContext";

//comoponente que contine el activador de animacion del Carrito y wishlist desde la barra de navegacion (menu)
const Content=({ sideBar, setSideBar, sideBarWish, setSideBarWish})=> {
  const {getUnits,vacio}= useCartContext();

  useEffect(() => {
  }, [vacio])


    return (
    <motion.div className='div'
        animate={{
          scale: 1,
          opacity: 1
        }}
        transition={{ type: "spring", bounce: 0, duration: 0.4 }}
      >
        <motion.i className="fas fa-heart" onClick={() => setSideBarWish((sideBarWish) => !sideBarWish)}>{sideBarWish}</motion.i>Wish-list
        <motion.i className="fa fa-shopping-cart"  onClick={() => setSideBar((sideBar) => !sideBar)}>{sideBar}</motion.i>Carrito {vacio && <span className="conteo" >{getUnits()}</span>}
    </motion.div>
    );
}
export default Content;